import { Badge } from '@bbpos/ui';
import type { SalesOrderStatus } from './types';

interface StatusMeta {
  label: string;
  badgeVariant: 'confirmed' | 'partial' | 'completed' | 'cancelled';
  customClass?: string;
}

const STATUS_MAP: Record<SalesOrderStatus, StatusMeta> = {
  CONFIRMED: { label: 'Confirmed', badgeVariant: 'confirmed' },
  PARTIALLY_DELIVERED: { label: 'Partially delivered', badgeVariant: 'partial' },
  DELIVERED: {
    label: 'Delivered',
    badgeVariant: 'completed',
    customClass: 'bg-violet-100 text-violet-700 dark:bg-violet-900/30 dark:text-violet-300',
  },
  COMPLETED: { label: 'Completed', badgeVariant: 'completed' },
  CANCELLED: { label: 'Cancelled', badgeVariant: 'cancelled' },
};

export function SalesOrderStatusBadge({ status, size = 'sm' }: { status: SalesOrderStatus; size?: 'sm' | 'md' }) {
  const meta = STATUS_MAP[status] ?? STATUS_MAP.CONFIRMED;
  if (meta.customClass) {
    return (
      <span className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium ${meta.customClass}`}>
        <span className="h-1.5 w-1.5 rounded-full bg-current" />
        {meta.label}
      </span>
    );
  }
  return (
    <Badge variant={meta.badgeVariant} size={size}>
      <span className="flex items-center gap-1.5">
        <span className="h-1.5 w-1.5 rounded-full bg-current" />
        {meta.label}
      </span>
    </Badge>
  );
}
